import type React from "react";

interface Props {
  children: React.ReactNode;
}

export const NamedDivider: React.FC<Props> = ({ children }) => (
  <div className="sid-named-divider">
    <hr className="sid-named-divider__rule" />
    <p className="sid-named-divider__text">{children}</p>
  </div>
);
